<template>
  <div>
    <v-card flat tile>
      <v-toolbar flat color="white">
        <v-toolbar-title>
          <v-icon class="mb-1">mdi-cash-multiple</v-icon>
          Cargos por guía
        </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-col cols="3">
          <v-text-field
            v-model="awb"
            label="Guía (AWB)"
            placeholder="406-03650286"
            hide-details
            clearable
            @keyup.enter="buscar()"
          ></v-text-field>
        </v-col>
        <v-btn small color="primary" :loading="cargando" :disabled="!awb" @click="buscar()">
          <v-icon left>mdi-magnify</v-icon> Consultar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn small color="success" :loading="exportando" :disabled="!resultado" @click="exportar()">
          <v-icon left>mdi-file-excel</v-icon> Exportar
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-alert v-if="mensaje" dense outlined type="info">{{ mensaje }}</v-alert>

        <div v-if="resultado">
          <p class="subtitle-1">
            Guía <strong>{{ resultado.cabecera.AWB }}</strong>, fecha {{ resultado.cabecera.FECHA }}
          </p>

          <v-tabs v-model="pestana" height="36" class="mb-3">
            <v-tab>Cargos</v-tab>
            <v-tab>Facturación</v-tab>
          </v-tabs>

          <!-- v-show: cambiar de pestana no debe perder los ajustes aun sin aprobar. -->
          <FacturacionGuia v-if="facturacionAbierta" v-show="pestana === 1" :cabecera-id="cabeceraId" />

          <div v-show="pestana === 0">
          <v-alert v-if="resultado.errores.length" dense outlined type="error">
            Hay líneas sin tarifa: sus montos y totales quedan sin calcular hasta corregirlas.
            <ul>
              <li v-for="(error, i) in resultado.errores" :key="i">
                {{ error.CONCEPTO }} (producto {{ error.PRO_ID }}): {{ error.msg }}
              </li>
            </ul>
          </v-alert>

          <v-alert v-if="resultado.avisos.length" dense outlined type="warning">
            <ul>
              <li v-for="(aviso, i) in resultado.avisos" :key="i">{{ aviso.msg }}</li>
            </ul>
          </v-alert>

          <v-simple-table dense class="cargos-tabla">
            <thead>
              <tr>
                <th>Finca</th>
                <th>Concepto</th>
                <th>HAWB</th>
                <th class="text-right">Extended Price</th>
                <th class="text-right">% Duty</th>
                <th class="text-right">Duty</th>
                <th class="text-right">MPF</th>
                <th class="text-right">Total</th>
              </tr>
            </thead>
            <tbody v-for="grupo in grupos" :key="grupo.SCLIENTE_ID">
              <tr class="grey lighten-3">
                <td colspan="8" class="font-weight-bold">{{ grupo.SCLIENTE_NOMBRE }} ({{ grupo.PAIS || "sin país" }})</td>
              </tr>
              <tr v-for="linea in grupo.lineas" :key="linea.INVOICE_ID">
                <td>{{ linea.FINCA_NOMBRE }}</td>
                <td>{{ linea.CONCEPTO }}</td>
                <td>{{ linea.NUM_GUIA_FINCA }}</td>
                <td class="text-right">{{ monto(linea.EXTENDED_PRICE) }}</td>
                <td class="text-right">{{ monto(linea.PCT_DUTY) }}</td>
                <td class="text-right">{{ monto(linea.DUTY) }}</td>
                <td class="text-right">{{ monto(linea.MPF) }}</td>
                <td class="text-right">{{ monto(linea.TOTAL) }}</td>
              </tr>
              <tr class="font-weight-bold">
                <td colspan="2">Total {{ grupo.SCLIENTE_NOMBRE }}</td>
                <td>{{ grupo.TOTAL_HAWB }} HAWB</td>
                <td class="text-right">{{ monto(grupo.EXTENDED_PRICE) }}</td>
                <td></td>
                <td class="text-right">{{ monto(grupo.DUTY) }}</td>
                <td class="text-right">{{ monto(grupo.MPF) }}</td>
                <td class="text-right">{{ monto(grupo.TOTAL) }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="font-weight-bold grey lighten-2">
                <td colspan="3">Total de la guía</td>
                <td class="text-right">{{ monto(resultado.total.EXTENDED_PRICE) }}</td>
                <td></td>
                <td class="text-right">{{ monto(resultado.total.DUTY) }}</td>
                <td class="text-right">{{ monto(resultado.total.MPF) }}</td>
                <td class="text-right">{{ monto(resultado.total.TOTAL) }}</td>
              </tr>
            </tfoot>
          </v-simple-table>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import FacturacionGuia from "./FacturacionGuia.vue";

export default {
  name: "CargosGuia",
  components: { FacturacionGuia },
  data: () => ({
    pestana: 0,
    facturacionAbierta: false,
    awb: "",
    cabeceraId: null,
    cargando: false,
    exportando: false,
    resultado: null,
    mensaje: "",
  }),
  computed: {
    grupos() {
      if (!this.resultado) {
        return [];
      }
      return this.resultado.subclientes.map((subcliente) => ({
        ...subcliente,
        lineas: this.resultado.lineas.filter((l) => l.SCLIENTE_ID === subcliente.SCLIENTE_ID),
      }));
    },
  },
  watch: {
    pestana(valor) {
      if (valor === 1) {
        this.facturacionAbierta = true;
      }
    },
  },
  methods: {
    ...mapMutations("master", ["setUrl"]),
    ...mapActions("master", ["requestApi"]),

    // Un monto sin calcular se muestra como raya, para no confundirlo con 0.
    monto(valor) {
      if (valor === null || valor === undefined) {
        return "—";
      }
      return Number(valor).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },

    buscar() {
      if (this.awb) {
        this.cabeceraId = null;
        this.consultar({ awb: this.awb });
      }
    },

    consultar(filtro) {
      this.cargando = true;
      this.resultado = null;
      this.mensaje = "";
      this.setUrl("api/cargos-guia");
      this.requestApi({ method: "POST", data: filtro })
        .then((res) => {
          if (res.data.success) {
            this.resultado = res.data;
            this.cabeceraId = res.data.cabecera.CABECERA_ID;
            this.awb = res.data.cabecera.AWB;
          } else {
            this.mensaje = res.data.msg;
          }
        })
        .catch(() => {})
        .then(() => {
          this.cargando = false;
        });
    },

    exportar() {
      this.exportando = true;
      this.setUrl("api/cargos-guia-exportar");
      this.requestApi({ method: "POST", data: { cabecera_id: this.cabeceraId } })
        .then((res) => {
          const a = document.createElement("a");
          a.href = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," + res.data.datos;
          a.download = res.data.archivo;
          a.click();
        })
        .catch(() => {})
        .then(() => {
          this.exportando = false;
        });
    },
  },
  mounted() {
    const cabeceraId = this.$route.query.cabecera_id;
    if (cabeceraId) {
      this.consultar({ cabecera_id: cabeceraId });
    }
  },
};
</script>

<style scoped>
.cargos-tabla td {
  white-space: nowrap;
}
</style>
